/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

function initMiniGallery(scope = document) {
  const galleries = scope.querySelectorAll('.mini-gallery');

  galleries.forEach((gallery, index) => {
    const thumbs = gallery.querySelectorAll('.mini-gallery__thumb');
    const mainImage = gallery.querySelector('.mini-gallery__main img');

    const cardInfoBottom = document.querySelector('.card-info-bottom');

    if (cardInfoBottom) {
      const fieldsets = cardInfoBottom.querySelectorAll('.product-form__swatch');
      const fieldsetCount = fieldsets.length;
  
      if (fieldsetCount === 3) {
        cardInfoBottom.style.height = window.innerWidth < 540 ? '300px' : '325px';
      } else if (fieldsetCount === 4) {
        cardInfoBottom.style.height = '360px';
      }
    }

    document.querySelectorAll('form.js-product-form').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        const sectionId = form.closest('section') ? form.closest('section').id : null;
        const quantityInput = document.querySelector(`#Quantity-${form.id}-${sectionId}`);
        
        if (quantityInput) {
          let hiddenQty = form.querySelector('input[name="quantity"]');
          if (!hiddenQty) {
            hiddenQty = document.createElement('input');
            hiddenQty.type = 'hidden';
            hiddenQty.name = 'quantity';
            form.appendChild(hiddenQty);
          }
          hiddenQty.value = quantityInput.value;
        }
      });
    });

    if (!mainImage) return;

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const newSrc = thumb.getAttribute('data-main-image');
        if (newSrc) {
          mainImage.setAttribute('src', newSrc);
          thumbs.forEach(t => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
          console.log(`[MiniGallery] Image changed to ${newSrc}`);
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  console.log('[MiniGallery] DOM loaded');
  initMiniGallery();
});

const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (!(node instanceof HTMLElement)) return;

      if (node.matches('.mini-gallery')) {
        console.log('[MiniGallery] .mini-gallery element added');
        initMiniGallery(node);
      } else if (node.querySelector && node.querySelector('.mini-gallery')) {
        console.log('[MiniGallery] .mini-gallery found inside new node');
        initMiniGallery(node);
      }
    });
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
